export const verticalBucketsSource = 'vertical-buckets';
